"use client"

import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import Sidebar from '../DoctorsDashboard/AdminDashboard/Sidebar';
import RepsSidebar from '../RepDashboard/RepsDashboard/RepsSidebar/RepsSidebar';
import { SidebarProvider, useSidebar } from '@/context/SidebarContext';

// Children are rendered unconditionally. This used to hide them behind an
// `is404` flag that started as `true` and was only cleared in a browser-side
// effect (reading `document.title`), which meant the server always sent an
// empty shell for every public page — product data and reviews only existed
// inside the JS payload, so search engines and any non-JS client saw nothing.
// Next's own 404 never renders inside this layout (unknown routes use the
// root not-found, and the pages here render their own "not found" UI), so
// the flag never had a real case to serve.
const LayoutContent = ({ children }) => {
	const users = useSelector((state) => state?.userData?.userData?.user);
	const { isMobileSidebarOpen, closeMobileSidebar } = useSidebar();

	// Close sidebar when screen size changes to desktop
	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth >= 1024) {
				closeMobileSidebar();
			}
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [closeMobileSidebar]);

	return (
		<div className="flex h-screen overflow-hidden">
			{/* Mobile sidebar with smooth animation */}
			{users && (
				<>
					{/* Overlay */}
					<div
						className={`lg:hidden fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 ease-in-out ${
							isMobileSidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
						}`}
						onClick={closeMobileSidebar}
					/>
					{/* Sidebar */}
					<div
						className={`lg:hidden fixed inset-y-0 left-0 z-50 w-[250px] bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
							isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'
						}`}
					>
						{users?.type === "reps" ? <RepsSidebar onCloseMobile={closeMobileSidebar} /> : <Sidebar onCloseMobile={closeMobileSidebar} />}
					</div>
				</>
			)}

			{/* Desktop sidebar */}
			{users && (
				<div className="hidden lg:block flex-shrink-0 w-[250px]">
					{users?.type === "reps" ? <RepsSidebar /> : <Sidebar />}
				</div>
			)}

			<div className={`flex-1 flex flex-col overflow-hidden ${users && (users?.type === "clinic" || users?.type === "physician") ? "main-wrapper" : ""}`}>
				{children}
			</div>
		</div>
	)
}

const Layout = ({ children }) => {
	return (
		<SidebarProvider>
			<LayoutContent>{children}</LayoutContent>
		</SidebarProvider>
	)
}

export default Layout